import Layout from "../Layout/Layout";

import { Helmet } from "react-helmet-async";

import { MainTitleContainer, MainTitle, MainSubtitle } from "../Workshop/StylesWorkshop";

import { API_BASE_URL } from "../../config/api";
import {
  SearchBox,
  Search,
  SearchIcon,
  ProductsContainer,
  ProductStyled,
  ProductMsg,
  ShowMoreBtn,
  Select,
} from "./StylesShop";

import { useEffect, useId, useContext, useReducer } from "react";
import { Context } from "../Context/ContextProvider";

import ProductLoader from "./Loader";

import Product from "./Product";

import ShopImg from "../../assets/Shop.png";

export default function Shop() {
  const { showPrice, refresh, reloadProducts } = useContext(Context);

  const initialState = {
    products: [],
    loading: true,
    isMobile: false,
    limit: 10,
    msgProducts: "No hay productos cargados!",
    maxProducts: 0,
    back: false,
    searchValue: "",
    categories: [],
    category: false,
  };
  function reducer(state, { type, payload }) {
    switch (type) {
      case "setProducts":
        return { ...state, products: payload };
      case "setLoading":
        return { ...state, loading: payload };
      case "setIsMobile":
        return { ...state, isMobile: payload };
      case "setLimit":
        return { ...state, limit: payload };
      case "setMsgProducts":
        return { ...state, msgProducts: payload };
      case "setMaxProducts":
        return { ...state, maxProducts: payload };
      case "setBack":
        return { ...state, back: payload };
      case "setSearchValue":
        return { ...state, searchValue: payload };
      case "setCategories":
        return { ...state, categories: payload };
      case "setCategory":
        return { ...state, category: payload };
      default:
        return state;
    }
  }
  const [state, dispatch] = useReducer(reducer, initialState);

  const loaderId = useId();

  const handleSearchChange = (e) => {
    const value = e.target.value;
    dispatch({ type: "setSearchValue", payload: value });
    if (value === "" && state.back) {
      dispatch({ type: "setBack", payload: false });
      reloadProducts();
    }
  };

  const handleSearch = (e) => {
    e.preventDefault();
  };

  const handleBack = () => {
    dispatch({ type: "setBack", payload: false });
    dispatch({ type: "setSearchValue", payload: "" });
    reloadProducts();
  };

  const handleLimit = () =>
    dispatch({
      type: "setLimit",
      payload: state.isMobile ? state.limit + 5 : state.limit + 10,
    });

  // Effect 1: Resize listener - runs once on mount
  useEffect(() => {
    const handleResize = () => {
      dispatch({ type: "setIsMobile", payload: window.innerWidth < 1000 });
    };

    handleResize(); // Set initial value
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Effect 2: Fetch categories - runs once on mount (static data)
  useEffect(() => {
    fetch(`${API_BASE_URL}/api/products/categoryNames`)
      .then((res) => res.json())
      .then((data) => dispatch({ type: "setCategories", payload: data }))
      .catch((err) => console.log(err));
  }, []);

  // Effect 3: Fetch products - runs when limit, category, or refresh changes
  useEffect(() => {
    dispatch({ type: "setLoading", payload: true });

    const categoryParam = state.category ? `&category=${state.category}` : "";

    fetch(`${API_BASE_URL}/api/products?limit=${state.limit}&offset=0${categoryParam}`)
      .then((res) => res.json())
      .then((data) => {
        dispatch({ type: "setProducts", payload: data });
        if (state.category && !data.length) {
          dispatch({ type: "setMsgProducts", payload: "No hay productos con esa categoria" });
        }
      })
      .finally(() => {
        setTimeout(() => dispatch({ type: "setLoading", payload: false }), 300);
      });
  }, [state.limit, refresh, state.category]);

  // Effect 4: Fetch product count - runs when category changes
  useEffect(() => {
    const endpoint = state.category
      ? `/api/products/category/${state.category.toUpperCase()}`
      : "/api/products/size";

    fetch(`${API_BASE_URL}${endpoint}`)
      .then((res) => res.json())
      .then((data) => {
        const count = state.category
          ? (Array.isArray(data) ? data.length : 0)
          : (data.documents || 0);
        dispatch({ type: "setMaxProducts", payload: count });
      })
      .catch((err) => {
        console.error("Error fetching product count:", err);
        dispatch({ type: "setMaxProducts", payload: 0 });
      });
  }, [state.category]);

  // Effect 5: Debounced search - runs when searchValue changes
  useEffect(() => {
    if (state.searchValue === "") return;

    const controller = new AbortController();
    const timer = setTimeout(() => {
      fetch(`${API_BASE_URL}/api/products/search`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ search: state.searchValue }),
        signal: controller.signal,
      })
        .then((res) => res.json())
        .then((data) => {
          const products = Array.isArray(data) ? data : [];
          if (!products.length) {
            dispatch({ type: "setMsgProducts", payload: "No se encontraron coincidencias" });
          }
          dispatch({ type: "setProducts", payload: products });
          dispatch({ type: "setMaxProducts", payload: products.length });
          dispatch({ type: "setBack", payload: true });
        })
        .catch((err) => {
          if (err.name !== "AbortError") console.error(err);
        });
    }, 300);

    return () => {
      clearTimeout(timer);
      controller.abort();
    };
  }, [state.searchValue]);

  const handleSelectCategories = (e) => {
    const value = e.target.value;
    dispatch({ type: "setLimit", payload: 10 }); // Reset limit when changing category
    dispatch({ type: "setCategory", payload: value === "false" ? false : value });
  };

  const loaders = [];
  const num = state.products.length || 5;
  for (let i = 0; i < num; i++) {
    loaders.push(
      <ProductStyled key={loaderId + i} loader={true}>
        <ProductLoader width={state.isMobile ? "155" : "200"} />
      </ProductStyled>
    );
  }

  return (
    <Layout>
      <Helmet>
        <title>Ventas</title>
        <meta charset="utf-8" />
        <meta
          name="description"
          content="Compra desde cualquier parte del país o acércate hasta nuestro local de ventas de
          repuestos"
        />
        <meta
          name="keywords"
          content="Venta de repuestos, Catalogo de repuestos, Repuestos camiones,recambios camiones"
        />
      </Helmet>
      <MainTitleContainer img={ShopImg}>
        <MainTitle>
          VENTA DE <br /> REPUESTOS
        </MainTitle>
        <MainSubtitle>
          Compra desde cualquier parte del país <br /> o acércate hasta nuestro local de ventas de repuestos.{" "}
        </MainSubtitle>
      </MainTitleContainer>
      <SearchBox onSubmit={handleSearch}>
        <div style={{ position: "relative", width: "69%", minWidth: "300px" }}>
          <Search
            required
            value={state.searchValue}
            onChange={handleSearchChange}
            type={"text"}
            placeholder={"¿Qué estas buscando?"}
          />
          <SearchIcon onClick={handleSearch} />
        </div>
        <input type="submit" hidden />
        <Select onChange={handleSelectCategories}>
          {state.categories.length ? (
            <>
              <option value={false}>Todas las categorias</option>
              {state.categories.map((item) => (
                <option key={item} value={item}>
                  {String(item).slice(0, 1) + String(item).slice(1).toLowerCase()}
                </option>
              ))}
            </>
          ) : (
            <option>Cargando categorias</option>
          )}
        </Select>
      </SearchBox>
      {state.back && <ShowMoreBtn onClick={handleBack}>Volver</ShowMoreBtn>}
      <ProductsContainer>
        {state.loading ? (
          loaders
        ) : state.products.length ? (
          state.products.map((item) => {
            return <Product key={item.id} item={item} showPrice={showPrice} />;
          })
        ) : (
          <ProductMsg>{state.msgProducts}</ProductMsg>
        )}
      </ProductsContainer>
      {state.products.length < state.maxProducts && <ShowMoreBtn onClick={handleLimit}>Mostrar más</ShowMoreBtn>}
    </Layout>
  );
}
